import * as React from 'react';
import { Textarea } from "soprasteria-ui-library";

interface IGeneralDentalReferralCompletionInformation {
    reasonForCompletion?: string;
}

export const GeneralDentalReferralCompletionInformation: React.FunctionComponent<IGeneralDentalReferralCompletionInformation> = ({ reasonForCompletion }) => {

    return (
        <>
            <div className="row">
                <h5 className="col-12">Kompletteringsbegäran</h5>
                <div className="col-6">
                    <Textarea label="Anledning" name="readonlyReasonForCompletion" defaultValue={reasonForCompletion} readonly inlineLabel />
                </div>
            </div>
            <hr />
        </>
    );
}